module.exports = __webpack_public_path__ + "img/maria-thalheim_hochaltar_2018_ref.56fa385f.jpg";